import AllLetterDetails from "./AllLetterDetail";

const allLetterRoutes = [
    {
        path: "allletterdetails",
        component: <AllLetterDetails />,
    },
];

const LetterManagementRoute = {
    path: "allletterdetails",
    component: <AllLetterDetails />,
};

export default allLetterRoutes;

export { LetterManagementRoute };